import * as types from './types';

const INITIAL_STATE = {
  columns: null,
  data: {}, // indexed by page to maintain server sort order
  loading: false,
  progress: 0,
  downloadInProgress: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GENERAL_REPORT_ARCHETYPE_FETCH_SUCCESS: {
      return {
        ...state,
        columns: action.payload.columns
      };
    }
    case types.GENERAL_REPORT_DATA_FETCH_START: {
      return {
        ...state,
        loading: true,
        progress: 5
      };
    }
    case types.GENERAL_REPORT_DATA_DOWNLOAD_PROGRESS_UPDATE: {
      const { progress } = action.payload;
      return { ...state, progress, downloadInProgress: progress > 0 && progress < 100 };
    }
    case types.GENERAL_REPORT_DATA_FETCH_SUCCESS: {
      const { loadingStatus } = action.payload;
      const { page, total } = loadingStatus;

      const payloadData = action.payload.data || [];
      const stateData = state.data || {};
      const data = payloadData.length > 0 ? { [page]: payloadData, ...stateData } : stateData;

      const newProgress = (Object.values(data).flat().length / total) * 100;
      const progress = Math.min(Math.max(state.progress, newProgress), 100);

      return {
        ...state,
        data,
        loading: false,
        progress
      };
    }
    case types.GENERAL_REPORT_DATA_CLEAR: {
      return {
        ...state,
        data: null,
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};
